export default __webpack_public_path__ + "static/media/progressmonitor-light-mode.421ac128.svg";